import React from 'react';
import { FiCalendar } from 'react-icons/fi';
import { Avatar } from '@/components/custom/avatar/avatar';
import { Badge } from '@/components/ui/badge';

export default function ChallengeSummary({ challenge }) {
  const initialDate = challenge?.['initial-date'] ? new Date(challenge['initial-date']).toLocaleDateString('pt-br') : '-';
  const endDate = challenge?.['end-date'] ? new Date(challenge['end-date']).toLocaleDateString('pt-br') : '-';
  const accuracyRate = challenge?.['accuracy-rate'] ?? 0;

  return (
    <section
      className="relative mb-6 flex flex-col overflow-hidden rounded-[24px] border border-neutral-100 bg-[var(--color-bg-cream)] p-6 shadow-card md:p-8"
      style={{ animation: 'trilha-in 380ms cubic-bezier(0.23, 1, 0.32, 1) 150ms both' }}
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 h-20 rounded-t-[24px]"
        style={{ background: 'linear-gradient(180deg, rgba(214,253,255,0.5) 0%, transparent 100%)' }}
      />

      <div className="relative flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="min-w-0 flex-1">
          <h1
            className="mb-2 text-2xl font-extrabold leading-snug"
            style={{ color: '#222731' }}
          >
            {challenge?.title}
          </h1>

          <p className="mb-0 flex items-center gap-2 text-sm font-semibold text-neutral-500">
            <FiCalendar className="h-4 w-4 text-mission" />
            Desafio da semana {initialDate} a {endDate}
          </p>

          <div className="mt-3 flex flex-wrap items-center gap-2">
            <Badge
              variant="info-soft"
              size="sm"
              title={challenge?.taxonomy?.name}
            >
              {challenge?.taxonomy?.name}
            </Badge>
            <Badge
              variant="success-soft"
              size="sm"
            >
              Acerto geral {accuracyRate}%
            </Badge>
          </div>
        </div>

        <div className="flex min-w-0 items-center gap-3 rounded-[16px] border border-neutral-100 bg-white/80 p-4 shadow-sm lg:min-w-[320px]">
          <Avatar
            className="size-20"
            src={challenge?.user?.image}
            alt="Imagem do usuário"
          />

          <div className="min-w-0">
            <p className="mb-1 text-xs font-bold text-neutral-500">Autoria</p>
            <h2
              className="mb-1 truncate text-base font-extrabold"
              style={{ color: '#222731' }}
              title={challenge?.user?.name}
            >
              {challenge?.user?.name}
            </h2>
            <p
              className="mb-0 truncate text-xs font-semibold text-neutral-500"
              title={challenge?.user?.institution?.name}
            >
              {challenge?.user?.institution?.name}
            </p>
            <p
              className="mb-0 truncate text-xs font-semibold text-neutral-500"
              title={challenge?.user?.institution?.regional?.name}
            >
              {challenge?.user?.institution?.regional?.name}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
